'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CurrencyCodes = require('self-service-api/constants/CurrencyCodes');

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = _CurrencyCodes.USD;

var ActiveCurrencyCode = function ActiveCurrencyCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.ACTIVE_CURRENCY_CODE_UPDATED:
      return payload.currency;

    default:
      return state;
  }
};

exports.default = ActiveCurrencyCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/ActiveCurrencyCode.js
// module id = 377
// module chunks = 3 4 5